import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import InternationalShippingServicesPage from '@/v2/components/pages/public-pages/international-shipping-services-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/public-pages/international-shipping-services-page'

interface InternationalShippingServicesPageProps {}

const Page: React.FC<InternationalShippingServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.international_shipping_services.title ?? ''}
        keywords={META_CONTENTS.international_shipping_services?.keywords ?? ''}
        description={META_CONTENTS.international_shipping_services?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <InternationalShippingServicesPage />
    </>
  )
}

export default Page
